<template>
    <div class="p-3">
        <h5 class="text-center">Kebijakan Privasi</h5>
        <h5 class="text-center">ATM/001/KP/I/0422/C</h5>
        <div class="text-justify">
            <p>
                Terima kasih telah menggunakan ArTrade <br>
                "Kebijakan Privasi" ini menjelaskan bagaimana kami mengumpulkan, menggunakan, memproses,
                dan mengungkapkan informasi pengguna, termasuk informasi pribadi yang terkait dengan
                kunjungan pengguna dan layanannya. <br>
                Jika ada istilah yang tidak ditentukan dalam "Kebijakan Privasi" ini (seperti "item layanan" atau
                "ArTrade"), definisinya sesuai dengan definisi kami dalam persyaratan layanan.
                Dalam kebijakan ini, "ArTrade", "kami" atau "milik kami" mengacu pada perusahaan PT Arisma
                Teknika Mesari yang bertanggung jawab atas informasi pengguna berdasarkan Kebijakan Privasi
                ini.
            </p>
            <p class="">
                <strong>1. Jenis informasi yang kami kumpulkan</strong><br>
                Kami mengumpulkan tiga jenis informasi.
            </p>
            <p >
                <strong>1.1 Informasi yang Pengguna berikan kepada kami</strong> <br>
                Informasi yang diperlukan untuk menggunakan ArTrade. Saat menggunakan ArTrade,
            kami meminta pengguna untuk memberikan dan mengumpulkan informasi pribadi. Informasi
            tersebut diperlukan untuk kontrak antara pihak pengguna dan pihak kami. Di samping itu, juga
            memungkinkan kami untuk mematuhi kewajiban hukum. Tanpa informasi tersebut, kami mungkin
            tidak dapat menyediakan semua layanan yang dibutuhkan pengguna dari platform ArTrade.
            </p>
            <p >
                <strong>1.1.1. Informasi akun</strong> <br>
                Saat pengguna mendaftar untuk akun ArTrade, kami meminta pengguna untuk
                memberikan nama lengkap nasabah, nomor telepon, alamat email, kata sandi, gambar profil, dan
                informasi lainnya. <br>

                Informasi verifikasi identitas. Untuk membantu menciptakan dan memelihara lingkungan
                terpercaya, kami dapat mengumpulkan informasi verifikasi identitas (seperti foto, paspor, KTP,
                atau SIM yang diizinkan oleh undang-undang yang berlaku) atau informasi verifikasi lainnya. <br>

                Informasi pembayaran. Untuk menggunakan fungsi ArTrade tertentu (seperti item layanan
                berlangganan), kami mungkin meminta Pengguna untuk memberikan informasi keuangan tertentu
                (seperti informasi rekening bank atau kartu kredit Pengguna) untuk memfasilitasi proses
                pembayaran. Selain itu, juga korespondensi dengan ArTrade dan anggota lainnya. Saat Pengguna
                berkomunikasi dengan ArTrade atau berkomunikasi dengan anggota lain melalui ArTrade, kami
                akan mengumpulkan informasi komunikasi Pengguna dan informasi apa pun yang Pengguna pilih
                untuk diberikan.
            </p>
            <p>
                <strong>1.1.2. Informasi yang pengguna pilih untuk diberikan kepada kami</strong> <br>
                Pengguna dapat memilih untuk memberikan informasi pribadi tambahan kepada kami
                untuk mendapatkan pengalaman nasabah yang lebih baik saat menggunakan ArTrade. Informasi
                tambahan ini akan diproses berdasarkan persetujuan sukarela pengguna. <br>

                Informasi profil tambahan. Pengguna dapat memilih untuk memberikan informasi data
                pribadi tambahan sebagai bagian dari data pribadi pengguna (seperti nama, jenis kelamin, bahasa
                pilihan, kota, tanggal lahir, dan deskripsi pribadi). Seperti yang ditunjukkan di pengaturan akun
                pengguna, beberapa informasi pribadi ini merupakan bagian dari halaman profil publik pengguna
                dan akan diungkapkan kepada orang lain. <br>

                Informasi pengendalian risiko perdagangan. Pengguna dapat memilih untuk menyediakan
                strategi pengendalian risiko yang digunakan saat mengatur transaksi akun. <br>

                Informasi lainnya. Pengguna juga dapat memilih untuk memberi kami informasi lain saat
                mengisi formulir, mencari, memperbarui, atau menambahkan informasi akun ArTrade,
                berpartisipasi dalam promosi, atau menggunakan fitur ArTrade lainnya.
            </p>
            <p>
                <strong>1.1.3. Informasi yang diperlukan untuk menggunakan layanan pembayaran</strong> <br>
                Pengontrol data pembayaran perlu mengumpulkan informasi berikut. Informasi tersebut
                diperlukan untuk kinerja penuh kontrak dengan pengguna dan kepatuhan terhadap hukum yang
                relevan (seperti peraturan anti pencucian uang). Tanpa informasi ini, pengguna tidak akan dapat
                menggunakan layanan pembayaran. <br>

                Informasi pembayaran. Saat pengguna menggunakan layanan pembayaran, pengontrol data
                pembayaran memerlukan informasi keuangan tertentu (seperti informasi rekening bank atau kartu
                kredit Pengguna) untuk memproses pembayaran dan mematuhi hukum yang relevan.<br>

                Verifikasi identitas dan informasi lainnya. Jika pengguna merupakan penyedia layanan,
                pengontrol data pembayaran mungkin memerlukan informasi verifikasi identitas (seperti foto
                KTP, paspor, KTP, atau SIM) atau informasi verifikasi lainnya, tanggal lahir, alamat, alamat email pengguna, nomor telepon dan informasi lain untuk memverifikasi identitas pengguna, memberi
                pengguna layanan pembayaran dan mematuhi hukum yang relevan.
            </p>
            <p>
                <strong>1.2. Informasi yang kami kumpulkan secara otomatis saat Pengguna menggunakan ArTrade dan layanan pembayaran</strong> <br>
                Ketika pengguna menggunakan ArTrade dan layanan pembayarannya, kami akan
                mengumpulkan informasi tentang layanan yang pengguna gunakan secara otomatis dan bagaimana
                menggunakan layanan, termasuk informasi pribadi. Berdasarkan kepentingan sah kami untuk
                menyediakan dan meningkatkan fungsi ArTrade dan layanan pembayaran, informasi tersebut
                diperlukan untuk sepenuhnya menjalankan kontrak antara pengguna dan kamisehingga kami dapat
                mematuhi kewajiban hukum. <br>

                Informasi lokasi geografis. Saat pengguna menggunakan fungsi ArTrade tertentu, kami
                dapat mengumpulkan informasi lokasi tepat atau perkiraan pengguna, yang ditentukan oleh alamat
                IP atau data GPS perangkat seluler pengguna untuk memberi pengguna pengalaman nasabah yang
                lebih baik. Sebagian besar perangkat seluler memungkinkan pengguna untuk mengontrol atau
                menonaktifkan penggunaan layanan lokasi oleh aplikasi di menu pengaturan perangkat. Meskipun
                pengguna tidak sedang menggunakan aplikasi, ArTrade masih dapat mengumpulkan informasi ini
                jika pengaturan atau izin perangkat pengguna memungkinkan koneksi ini dibuka. <br>

                Gunakan informasi. Kami akan mengumpulkan informasi tentang interaksi pengguna
                dengan ArTrade, seperti halaman yang pengguna lihat atau konten lain, item layanan yang
                pengguna cari, dan aktivitas lainnya yang dilakukan pengguna di ArTrade. <br>

                Data login dan informasi perangkat. Meskipun pengguna belum membuat atau masuk ke
                akun ArTrade, saat pengguna mengakses dan menggunakan ArTrade, kami akan secara otomatis
                mengumpulkan data masuk dan informasi perangkat. Informasi ini termasuk, tetapi tidak terbatas
                pada perincian penggunaan ArTrade pengguna (termasuk tautan ke aplikasi pihak ketiga), alamat
                IP, tanggal akses dan berapa kali, informasi perangkat keras dan perangkat lunak, informasi
                perangkat, informasi peristiwa perangkat, unik pengidentifikasi, data kerusakan, data Cookie, dan
                halaman yang telah Pengguna lihat atau hubungi sebelum dan sesudah menggunakan ArTrade. <br>

                Informasi mikrofon/kamera. Untuk memberikan layanan yang dipersonalisasi dan
                meningkatkan kualitas layanan, atau merekomendasikan layanan yang lebih baik atau lebih sesuai
                untuk pengguna, pengguna dapat memilih untuk menggunakan mikrofon/perangkat kamera untuk
                input suara (misalnya pesan suara, pencarian suara) atau mengambil gambar dan mengunggah.
                Kami perlu mengumpulkan konten suara/foto Pengguna dan melakukan pemrosesan yang
                diperlukan. <br>

                Cookie dan teknologi serupa. Untuk mengoptimalkan situs web kami, kami menggunakan
                cookie (file teks kecil). Saat pengguna menelusuri situs web kami, kami akan menyimpan
                informasi tertentu di komputer pengguna atau perangkat terminal lainnya dalam bentuk "Cookies".
                Cookies dapat membantu kita dalam banyak hal. Misalnya, meningkatkan keamanan situs web,
                menentukan frekuensi penggunaan situs web dan jumlah pengunjung, dan menganalisis bagaimana
                nasabah menggunakan situs web kami. <br>

                Cookie Sesi: Saat pengguna masuk ke situs web dengan nama nasabah dan kata sandi
                pengguna, kami akan menggunakan "cookie sesi". Cookie sesi memungkinkan situs web
                mengenali pengguna selama kunjungan pengguna, dan ketika pengguna selesai menjelajahi situs
                web kami (jendela browser ditutup), cookie sesi ini akan dihapus. <br>

                Cookie Tetap: Kami juga akan menggunakan cookie tetap. Penggunaan cookie persisten
                memungkinkan kami untuk mengidentifikasi nasabah yang mengunjungi kembali situs,
                memungkinkan kami untuk terus meningkatkan produk kami dan memberi pengguna pengalaman
                layanan yang lebih baik. Cookies persisten ini tidak mengandung informasi pengenal pribadi.
                Informasi yang disimpan dalam cookie tidak akan dicocokkan dengan informasi pribadi pengguna
                setiap saat. <br>

                Cookie Masuk: Saat pengguna menggunakan fungsi "masuk ke komputer ini secara
                otomatis", kami akan menggunakan cookie tetap. Dalam hal ini, file cookie akan disimpan secara
                permanen di hard drive komputer pengguna, kecuali jika pengguna menghapusnya secara manual
                menggunakan browser atau perangkat lunak sistem operasi. Saat pengguna menggunakan situs
                web lagi, situs web akan membaca cookie ini dan mengetahui informasi relevan pengguna, dan
                pengguna dapat masuk secara otomatis. Cookie ini berisi nomor ID. Informasi login pengguna dan
                kata sandi pengguna tidak akan disimpan. <br>

                Cookie Afiliasi: Kami akan menggunakan cookie saat pengguna mengklik untuk
                mengunjungi situs web kami melalui lokasi iklan mitra ArTrade. Cookies ini digunakan untuk
                tujuan penagihan untuk mitra ArTrade dan tidak mengandung informasi pribadi apa pun. Pada
                jadwal penagihan, informasi yang dilihat oleh mitra yang mengundang pengguna untuk mendaftar
                ArTrade hanya disajikan dalam bentuk anonim; mitra tidak dapat melacak pengguna berdasarkan
                informasi yang diberikan. <br>
                Hak untuk menolak: Pengguna dapat melarang penyimpanan Cookie melalui browser
                pengguna, menggunakan Cookie untuk membatasi situs web tertentu, atau mengatur cara browser
                pengguna untuk memberi tahu pengguna saat cookie diterima, untuk mencegah penggunaan
                Cookie dan menolak untuk membuat tujuan profil penggunaan. Pengguna juga dapat menghapus
                cookie ini dari hard drive pengguna kapan saja, tetapi perlu diketahui bahwa jika pengguna
                menolak cookie sesi, pengguna mungkin tidak dapat menggunakan platform kami. <br>

                Transaksi pembayaran informasi. Entitas pembayaran ArTrade akan mengumpulkan
                informasi transaksi pembayaran pengguna di ArTrade, termasuk instrumen pembayaran yang
                digunakan, tanggal dan waktu, jumlah pembayaran, tanggal efektif instrumen pembayaran dan
                kode pos penagihan, alamat email PayPal, informasi IBAN, alamat pengguna, dan detail transaksi
                terkait lainnya. Informasi tersebut diperlukan untuk memenuhi kontrak antara pengguna dan kami.
                Di samping itu, juga untuk menyediakan layanan pembayaran.
            </p>
            <p>
                <strong>1.3. Informasi yang kami kumpulkan melalui pihak ketiga</strong> <br>
                Entitas pembayaran ArTrade dan ArTrade dapat mengumpulkan informasi tentang
                pengguna (termasuk informasi pribadi) yang diberikan oleh pihak lain saat menggunakan ArTrade
                dan layanan pembayaran, atau memperoleh informasi dari saluran lain, dan berkomunikasi dengan
                kami melalui ArTrade dan integrasi layanan pembayaran. Kami tidak akan mengontrol,
                mengawasi, atau menanggapi bagaimana pihak ketiga yang memberikan informasi Pengguna
                menangani data pribadi pengguna, dan permintaan informasi apa pun untuk pengungkapan
                informasi pribadi Pengguna yang dikirimkan kepada kami harus dikirim langsung ke pihak ketiga
                tersebut. <br>

                Layanan pihak ketiga. Jika pengguna mengaitkan akun ArTrade pengguna dengan layanan
                pihak ketiga (seperti Google, Facebook, WeChat) atau menggunakan layanan pihak ketiga untuk
                masuk ke akun ArTrade pengguna, layanan pihak ketiga yang relevan dapat mengirimkan
                informasi pendaftaran pengguna kepada kami di layanan dan informasi profil pribadi. Informasi
                bervariasi dari satu layanan ke layanan lainnya, dan dikendalikan oleh layanan yang relevan atau
                yang pengguna izinkan melalui pengaturan privasi layanan yang relevan. <br>

                Informasi akun perdagangan dari platform pihak ketiga. Jika pengguna mengikat akun
                perdagangan pihak ketiga dengan ArTrade, pengguna akan mengizinkan ArTrade untuk
                mendapatkan informasi tentang akun perdagangan pengguna di platform pihak ketiga (seperti
                informasi broker, nama akun, kata sandi hanya-baca, data transaksi, dll.). <br>

                Informasi perilaku nasabah yang dikumpulkan oleh alat pihak ketiga. Misalnya, gunakan
                alat statistik pihak ketiga untuk mengumpulkan informasi tentang perilaku klik pengguna, perilaku
                browsing, dan waktu tinggal halaman di ArTrade. <br>

                Sumber lain. Jika diizinkan oleh hukum yang berlaku, kami dapat memperoleh informasi
                tambahan tentang pengguna, seperti data demografis atau informasi deteksi penipuan, dari
                penyedia layanan pihak ketiga dan/atau mitra, dan menggabungkan informasi tersebut dengan
                integrasi informasi pengguna. Misalnya, kami dapat memperoleh hasil informasi pemeriksaan latar
                belakang (dengan persetujuan pengguna bila diperlukan) atau peringatan penipuan dari penyedia
                layanan (layanan verifikasi identitas) untuk pencegahan penipuan dan penilaian risiko. Kami dapat
                memperoleh informasi dan informasi pengguna tentang aktivitas pengguna di dalam dan di luar
                ArTrade melalui mitra kami.
            </p>
            <p>
                <strong>2. Bagaimana kami menggunakan informasi yang dikumpulkan</strong> <br>
                Kami menggunakan, menyimpan, dan memproses informasi pengguna (termasuk
                informasi pribadi) untuk menyediakan, memahami, meningkatkan, dan mengembangkan ArTrade,
                menciptakan dan memelihara lingkungan yang terpercaya dan lebih aman, serta mematuhi
                kewajiban hukum kami.
            </p>
            <p>
                <strong>2.1. Menyediakan, meningkatkan, dan mengembangkan ArTrade</strong> <br>
                <ul>
                    <li>Memungkinkan pengguna untuk mengakses dan menggunakan ArTrade.</li>
                    <li>Mengoperasikan, melindungi, meningkatkan, dan mengoptimalkan pengalaman ArTrade, seperti melakukan analisis dan penelitian.</li>
                    <li>Menyediakan layanan pelanggan.</li>
                    <li>Mengirimkan pengguna informasi layanan atau dukungan, seperti pembaruan,
                        peringatan keamanan, dan pemberitahuan akun.</li>
                    <li>
                        Operasikan, lindungi, tingkatkan, dan optimalkan pengalaman ArTrade untuk
                        memberi pengguna pengalaman yang dipersonalisasi dan disesuaikan (seperti
                        membuat rekomendasi item layanan atau peringkat dalam hasil pencarian).</li>
                    <li>Berdasarkan interaksi Pengguna dengan ArTrade, catatan pencarian dan pemesanan
                    pengguna, informasi profil dan preferensi pribadi Pengguna, dan konten lain yang
                    pengguna kirimkan ke ArTrade, kami akan melakukan analisis perilaku.
                    </li>
                    <li>Kami memproses informasi ini berdasarkan kepentingan yang sah untuk
                    meningkatkan ArTrade dan pengalaman anggota, yang diperlukan untuk kinerja penuh
                    kontrak dengan pengguna.</li>
                </ul>
            </p>
            <p>
                <strong>2.2. Membuat dan memelihara lingkungan yang terpercaya dan lebih aman</strong> <br>
                <ul>
                    <li>Mendeteksi dan mencegah penipuan, spam, penyalahgunaan, insiden keamanan, dan aktivitas berbahaya lainnya.</li>
                    <li>Lakukan investigasi keamanan dan penilaian risiko.</li>
                    <li>Verifikasi atau autentikasi informasi atau identifikasi yang pengguna berikan (seperti
                    memverifikasi alamat fasilitas tempat tinggal pengguna atau membandingkan foto
                    pada identifikasi pengguna dengan foto lain yang pengguna berikan).</li>
                    <li>Periksa database terhadap sumber informasi lain, termasuk latar belakang atau
                    investigasi polisi dalam batas yang diizinkan oleh hukum yang berlaku dan
                    berdasarkan persetujuan pengguna jika diperlukan.</li>
                    <li>Patuhi kewajiban hukum kami.</li>
                    <li>Selesaikan setiap perselisihan antara pihak kami dan pihak penyedia layanan mana pun
                        dan terapkan perjanjian kami dengan pihak ketiga.
                    </li>
                    <li>Terapkan persyaratan layanan kami dan kebijakan lainnya.</li>
                    <li>
                        Berdasarkan interaksi pengguna dengan ArTrade, informasi profil pribadi pengguna,
                    dan konten lain yang pengguna kirimkan ke ArTrade, serta informasi yang diperoleh
                    dari pihak ketiga, kami dapat melakukan analisis perilaku terkait aktivitas di atas.
                    Dalam beberapa kasus, jika proses otomatis mendeteksi bahwa anggota atau aktivitas
                    kami yang dianggap menimbulkan keamanan atau risiko lain untuk ArTrade, anggota
                    lain atau pihak ketiga, proses otomatis dapat membatasi atau menghentikan aksesnya
                    ke ArTrade.
                    </li>
                    <li>
                        Kami memproses informasi ini berdasarkan alasan yang sah untuk melindungi
                        kepentingan ArTrade, mengukur apakah kami sepenuhnya menjalankan kontrak
                        dengan pengguna, dan mematuhi hukum yang relevan.
                    </li>
                </ul>
            </p>
            <p>
                <strong>2.3. Menyediakan, mempersonalisasi, mengevaluasi, dan meningkatkan periklanan dan pemasaran kami</strong> <br>
                <ul>
                    <li>
                        Sesuai dengan preferensi pengguna, kirimkan pesan teks preferensial, pemasaran,
                        iklan, dan informasi lain yang mungkin menarik bagi pengguna (termasuk informasi
                        yang terkait dengan ArTrade, aktivitas, dan layanan mitra).
                    </li>
                    <li>
                        Personalisasi, evaluasi, dan tingkatkan periklanan kami.
                    </li>
                    <li>
                        Kelola program rujukan, penghargaan, survei, undian, kontes, atau promosi atau acara
                        lain yang diselenggarakan atau dikelola oleh ArTrade atau mitra bisnis pihak ketiga
                        kami.
                    </li>
                    <li>
                        Melakukan analisis perilaku berdasarkan karakteristik dan preferensi pengguna
                        (berdasarkan informasi yang pengguna berikan kepada kami, interaksi pengguna
                        dengan ArTrade, informasi yang diperoleh dari pihak ketiga, serta catatan pencarian
                        dan pemesanan pengguna) untuk mengirimkan SMS preferensial, pemasaran, Iklan,
                        dan informasi yang mungkin menarik bagi pengguna.
                    </li>
                    <li>
                        Mengingat bahwa kami memiliki kepentingan yang sah untuk melakukan aktivitas
                        pemasaran dan memberi pengguna produk atau layanan yang pengguna minati, kami
                        akan memproses informasi pribadi pengguna sesuai dengan tujuan yang tercantum
                        dalam artikel ini. Ikuti instruksi berhenti berlangganan yang terdapat dalam informasi
                        pemasaran kami atau ubah pengaturan pemberitahuan pengguna di akun ArTrade
                        pengguna, pengguna dapat memilih untuk tidak menerima informasi pemasaran kami.
                    </li>
                </ul>
            </p>
            <p>
                <strong>2.4. Bagaimana pengontrol data pembayaran menggunakan informasi yang dikumpulkan</strong> <br>
                <ul>
                    <li>
                        Memungkinkan pengguna untuk mengakses dan menggunakan layanan pembayaran.
                    </li>
                    <li>
                        Mendeteksi dan mencegah penipuan, spam, penyalahgunaan, insiden keamanan, dan
                        aktivitas berbahaya lainnya.
                    </li>
                    <li>
                        Lakukan investigasi keamanan dan penilaian risiko.
                    </li>
                    <li>
                        Periksa database dan sumber informasi lainnya.
                    </li>
                    <li>
                        Mematuhi kewajiban hukum (seperti peraturan anti pencucian uang).
                    </li>
                    <li>
                        Terapkan persyaratan pembayaran dan kebijakan lainnya.
                    </li>
                    <li>
                        Dengan persetujuan pengguna, kirimkan pesan teks preferensial, pemasaran, iklan, dan
                        informasi lain yang mungkin menarik bagi pengguna.
                    </li>
                    <li>
                        Pengontrol data pembayaran memproses informasi ini berdasarkan kepentingan yang
                        sah untuk meningkatkan layanan pembayaran dan pengalaman nasabah, yang
                        diperlukan untuk kinerja penuh kontrak dengan pengguna dan kepatuhan terhadap
                        hukum yang relevan.
                    </li>
                </ul>
            </p>

            <p>
                <strong>3. Berbagi dan pengungkapan</strong>
            </p>
            <p>
                <strong>3.1. Dengan persetujuan pengguna</strong> <br>
                Dengan persetujuan pengguna, kami dapat membagikan informasi pengguna (termasuk
                informasi pribadi) sesuai dengan instruksi ketika pengguna setuju, seperti ketika pengguna
                mengizinkan aplikasi atau situs web pihak ketiga untuk mengakses akun ArTrade pengguna, atau
                ketika pengguna berpartisipasi dalam kerja sama oleh ArTrade saat mempromosikan kegiatan yang
                dilakukan oleh mitra atau pihak ketiga.
            </p>
            <p>
                <strong>3.2. Mematuhi hukum, menanggapi persyaratan hukum, mencegah kerugian, dan melindungi hak-hak kita</strong> <br>
                Dalam batas yang sesuai yang diwajibkan dan diizinkan oleh hukum atau secara wajar
                diperlukan, entitas pembayaran ArTrade dan ArTrade dapat mengungkapkan informasi pengguna
                (termasuk informasi pribadi) ke pengadilan, lembaga penegak hukum, lembaga pemerintah, atau
                pihak ketiga yang berwenang untuk: (i) mematuhi kewajiban hukum, (ii) mematuhi prosedur
                hukum dan menanggapi klaim terhadap ArTrade, (iii) menanggapi penyelidikan kriminal, dugaan
                atau dugaan aktivitas ilegal, atau aktivitas lain yang dapat membuat kami, pengguna, atau nasabah
                lain, menghadapi tanggung jawab hukum Permintaan terkait yang diverifikasi, (iv) menjalankan
                atau mengelola persyaratan layanan, persyaratan pembayaran, atau perjanjian lainnya dengan
                anggota, atau (v) melindungi hak, properti atau keamanan pribadi ArTrade dan karyawannya,
                anggota atau anggota masyarakat. <br>

                Untuk mematuhi kewajiban hukum kami, melindungi kepentingan vital pengguna atau
                orang lain, atau untuk kepentingan sah kami atau pihak ketiga dalam menjaga keamanan ArTrade,
                mencegah cedera atau kejahatan, menjalankan atau membela hak hukum, atau mencegah
                kerusakan mungkin diperlukan upaya melakukan pengungkapan ini. <br>
                Dalam keadaan yang sesuai, kami akan mencoba memberi tahu anggota tentang
                persyaratan hukum, kecuali (i) proses hukum, perintah pengadilan yang kami terima, atau hukum
                yang berlaku melarang pemberitahuan; atau (ii) kami percaya bahwa memberikan pemberitahuan
                mungkin tidak efektif. Signifikansi dan ketidakabsahan, yang dapat membawa risiko kerusakan
                atau cedera pribadi kepada individu atau kelompok, atau membuat atau meningkatkan risiko
                penipuan terhadap properti, anggota, dan ArTrade (secara kolektif disebut sebagai "skenario
                risiko"). Jika kami belum mengeluarkan pemberitahuan karena alasan di atas, jika kami
                mengonfirmasi dengan itikad baik bahwa tindakan yang kami ambil tidak lagi dilarang oleh hukum
                dan tidak berlaku untuk skenario risiko, kami akan mencoba memberi tahu anggota terkait dengan
                permintaan setelah fakta.
            </p>
            <p>
                <strong>3.3. Penyedia layanan</strong> <br>
                Entitas pembayaran ArTrade dan ArTrade menggunakan berbagai penyedia layanan pihak
                ketiga untuk membantu kami menyediakan layanan yang terkait dengan ArTrade dan layanan
                pembayaran. Penyedia layanan mungkin berlokasi di dalam atau di luar wilayah Indonesia. <br>
                Misalnya, penyedia layanan dapat membantu kami dalam (i) memverifikasi atau
                mengautentikasi identitas pengguna, (ii) memeriksa informasi terhadap database publik, (iii)
                membantu kami melakukan pemeriksaan latar belakang, investigasi polisi, pencegahan penipuan
                dan penilaian risiko, (iv) pengembangan produk, pemeliharaan, dan debugging, (v)
                memungkinkan penyediaan layanan ArTrade melalui platform pihak ketiga dan alat perangkat
                lunak (misalnya melalui integrasi dengan API kami), atau (vi) menyediakan layanan pelanggan,
                iklan, atau layanan pembayaran. Untuk melakukan tugas ini atas nama kami, penyedia layanan
                tersebut memiliki akses terbatas ke informasi pengguna. Di samping itu, juga secara kontrak
                berkewajiban untuk melindungi informasi tersebut dan menggunakan informasi pengguna hanya
                sesuai dengan kebijakan privasi ini. <br>
                Entitas pembayaran ArTrade dan ArTrade perlu membagikan informasi pengguna
                (termasuk informasi pribadi) untuk memastikan bahwa perjanjian antara kami dan pengguna
                diterapkan sepenuhnya.
            </p>
            <p>
                <strong>3.4. Media sosial</strong> <br>
                Sebagaimana diizinkan oleh undang-undang yang berlaku, kami dapat menggunakan
                beberapa informasi pribadi terbatas Pengguna (seperti alamat email Pengguna) untuk melakukan
                hash dan membagikannya dengan platform media sosial (seperti Facebook atau Google) untuk
                menghasilkan pelanggan potensial, menarik lalu lintas ke situs web kami, atau mempromosikan
                produk dan layanan kami atau ArTrade. Aktivitas pemrosesan ini didasarkan pada kepentingan
                sah kami dalam aktivitas pemasaran untuk menyediakan produk atau layanan yang mungkin
                menarik bagi pengguna. <br>
                Platform media sosial yang kami gunakan untuk berbagi data pribadi pengguna tidak
                berada di bawah kendali atau pengawasan ArTrade. Oleh karena itu, setiap pertanyaan tentang
                bagaimana penyedia layanan platform media sosial pengguna menangani data pribadi pengguna
                harus ditujukan kepada penyedia tersebut. <br>
                Harap perhatikan bahwa pengguna dapat menghubungi kami kapan saja untuk meminta
                ArTrade menghentikan pemrosesan data pengguna untuk tujuan pemasaran langsung ini.
            </p>
            <p>
                <strong>3.5. Pemungutan dan pembayaran pajak pekerjaan</strong> <br>
                Di yurisdiksi ArTrade mendesak dan mewajibkan pengumpulan dan pembayaran pajak
                hunian sebagaimana dijelaskan di bagian "Pajak dan Biaya" dari persyaratan layanan. Jika
                diizinkan oleh undang-undang yang berlaku, penyedia layanan dan penerima layanan secara tegas
                memberi kami izin kepada otoritas pajak terkait mengungkapkan data penyedia layanan dan
                penerima layanan serta informasi lain yang terkait dengan mereka atau transaksinya. Namun, tidak
                terbatas pada nama penyedia layanan dan penerima layanan, tanggal dan jumlah transaksi, nomor
                identifikasi pajak, dan penyedia layanan pajak yang diterima (atau piutang) dari penerima layanan,
                dan informasi kontak tanpa pemberitahuan lebih lanjut.
            </p>
            <p>
                <strong>3.6. Mendaftar ke departemen pemerintah</strong> <br>
                Dalam yurisdiksi ArTrade mendesak atau mewajibkan penyedia layanan untuk mendaftar,
                memberi tahu, mendapatkan izin, atau lisensi aplikasi melalui ArTrade dengan departemen
                pemerintah daerah sesuai dengan hukum setempat. Kami mungkin secara teratur (jika berlaku)
                selama dan setelah proses aplikasi lembaga terkait membagikan informasi penyedia layanan yang
                berpartisipasi, seperti nama lengkap dan informasi kontak penyedia layanan, nomor identifikasi
                pajak, detail item layanan, dll.
            </p>
            <p>
                <strong>3.7. Transfer bisnis</strong> <br>
                Jika ArTrade terlibat atau terlibat dalam merger, akuisisi, reorganisasi, penjualan aset,
                kebangkrutan atau peristiwa kebangkrutan, kami dapat menjual, mentransfer, atau membagikan
                sebagian atau semua aset kami, termasuk yang terkait dengan transaksi tersebut atau Informasi
                yang direnungkan tentang pengguna terkait dengan transaksi (seperti uji tuntas). Dalam hal ini,
                kami akan memberitahu pengguna sebelum mentransfer informasi pribadi pengguna dan
                membuatnya mematuhi kebijakan privasi yang berbeda.
            </p>
            <p>
                <strong>3.8. Informasi ringkasan</strong> <br>
                Untuk kepatuhan terhadap peraturan, analisis industri dan pasar, klasifikasi demografis,
                pemasaran dan periklanan, dan tujuan bisnis lainnya, kami juga akan membagikan informasi
                agregat (informasi gabungan tentang pengguna kami, informasi tersebut tidak lagi
                mengidentifikasi atau menunjuk ke orang tertentu pengguna individu) dan informasi anonim
                lainnya.
            </p>
            <p>
                <strong>4. Informasi penting lainnya</strong>
            </p>
            <p>
                <strong>4.1. Analisis komunikasi pengguna</strong> <br>
                Kami dapat meninjau, menelusuri, atau menganalisis komunikasi pengguna di ArTrade
                untuk pencegahan penipuan, penilaian risiko, kepatuhan terhadap peraturan, investigasi,
                pengembangan produk, penelitian, dan dukungan pelanggan. Misalnya, dalam pencegahan
                penipuan, kami dapat meninjau dan menganalisis informasi, menyembunyikan informasi kontak,
                dan informasi yang mengarah ke situs web lain. Terkadang, kami juga akan menelusuri, meninjau,
                atau menganalisis informasi untuk tujuan debugging, meningkatkan, dan memperluas pro pasokan
                saluran. Jika memungkinkan secara wajar, kami juga akan meninjau atau menganalisis informasi
                secara otomatis. Namun, dari waktu ke waktu, kami mungkin perlu meninjau beberapa komunikasi
                secara manual (misalnya untuk investigasi penipuan dan dukungan pelanggan) atau mengakses
                dan meningkatkan fungsionalitas alat otomatis ini. Kami tidak akan meninjau, menelusuri, atau
                menganalisis komunikasi Pengguna untuk mengirimkan informasi pemasaran pihak ketiga kepada
                pengguna. Selain itu, juga tidak akan menjual ulasan atau analisis komunikasi ini. <br>
                Pelaksanaan aktivitas ini didasarkan pada ArTrade untuk memastikan kepatuhan terhadap
                hukum yang berlaku dan ketentuan kami, mencegah penipuan, mempromosikan keamanan, dan
                meningkatkan serta memastikan bahwa kami sepenuhnya menjalankan kepentingan yang sah dari
                layanan kami.
            </p>
            <p>
                <strong>5. Mitra dan integrasi pihak ketiga</strong> <br>
                ArTrade mungkin berisi tautan ke situs web atau layanan pihak ketiga, seperti integrasi
                pihak ketiga, layanan merek, atau layanan merek pihak ketiga ("mitra pihak ketiga"). ArTrade
                tidak memiliki atau mengontrol mitra pihak ketiga ini. Saat pengguna berinteraksi dengan mereka,
                pengguna dapat langsung memberikan informasi kepada mitra pihak ketiga, ArTrade, atau
                keduanya. Terkait dengan pengumpulan, penggunaan, dan pengungkapan informasi, mitra pihak
                ketiga ini memiliki aturannya sendiri. Kami ingin pengguna memeriksa kebijakan privasi situs web
                lain yang pengguna kunjungi.
            </p>
            <p>
                <strong>6. Hak Pengguna</strong> <br>
                Pengguna dapat menghubungi kami untuk menggunakan hak apa pun yang dijelaskan
                dalam artikel ini sebelum pengontrol data ArTrade dan pengontrol data pembayaran berlaku.
                Harap dicatat bahwa kami mungkin meminta pengguna untuk memverifikasi identitas pengguna
                sebelum mengambil tindakan lebih lanjut atas permintaan pengguna.
            </p>
            <p>
                <strong>6.1. Mengelola informasi pengguna</strong> <br>
                Pengguna dapat mengakses dan memperbarui beberapa informasi Pengguna melalui pengaturan akun Pengguna.
            </p>
            <p>
                <strong>6.2. Informasi yang tidak akurat atau tidak lengkap</strong> <br>
                Pengguna berhak meminta kami untuk mengoreksi informasi pribadi pengguna yang tidak
                akurat atau tidak lengkap (dan informasi yang tidak dapat pengguna perbarui sendiri di akun
                ArTrade pengguna).
            </p>
            <p>
                <strong>6.3. Akses dan transfer data</strong> <br>
                Di beberapa yurisdiksi, hukum yang berlaku mungkin memberi pengguna hak untuk
                meminta salinan informasi pribadi pengguna yang kami pegang. Pengguna mungkin juga memiliki
                hak untuk meminta salinan informasi pribadi pengguna yang kami miliki dalam format terstruktur,
                universal, dapat dibaca mesin, dan/atau meminta agar kami mengirimkan informasi ini ke penyedia
                layanan lain (jika kasus yang memungkinkan secara teknis).
            </p>
            <p>
                <strong>6.4. Penyimpanan dan penghapusan data</strong> <br>
                Biasanya kami hanya menyimpan informasi pribadi pengguna untuk jangka waktu yang
                diperlukan. Hal itu bertujuan untuk memenuhi kontrak antara pengguna dan kami serta mematuhi
                kewajiban hukum kami. Jika pengguna tidak lagi ingin kami menggunakan informasi pengguna
                untuk memberi pengguna ArTrade, Pengguna dapat meminta kami untuk menghapus informasi
                pribadi pengguna dan menutup akun ArTrade pengguna. Harap dicatat hal-hal berikut jika
                pengguna meminta kami untuk menghapus informasi pribadi pengguna. <br>

                Kami dapat menyimpan beberapa informasi pribadi pengguna untuk memenuhi
                kepentingan bisnis kami yang sah, seperti deteksi dan pencegahan penipuan serta meningkatkan
                keamanan. Misalnya, jika kami menonaktifkan akun ArTrade karena alasan penipuan atau
                keamanan, kami dapat menyimpan informasi tertentu dari akun ArTrade untuk mencegah anggota
                membuat akun ArTrade baru pada masa mendatang. <br>

                Untuk mematuhi kewajiban hukum kami, kami dapat menyimpan dan menggunakan
                informasi pribadi pengguna. Misalnya, entitas pembayaran ArTrade dan ArTrade dapat
                menyimpan beberapa informasi pengguna untuk kewajiban pajak, pelaporan hukum, dan audit.
                Meskipun akun ArTrade pengguna dibatalkan, informasi yang pengguna bagikan kepada
                orang lain masih dapat ditampilkan secara publik di ArTrade. Akan tetapi, atribusi pengguna
                tentang informasi ini akan dihapus. Selain itu, beberapa salinan informasi pengguna (seperti
                catatan login) mungkin disimpan dalam database kami, tetapi akan dibedakan dari pengenal
                pribadi. <br>

                Karena kami akan mempertahankan ArTrade untuk mencegah kehilangan dan kerusakan
                yang tidak disengaja atau berbahaya, salinan sisa informasi pribadi Pengguna tidak dapat dihapus
                dari sistem cadangan kami dalam waktu yang terbatas.
            </p>
            <p>
                <strong>6.5. Pencabutan persetujuan dan pembatasan pemrosesan</strong> <br>
                Jika pengguna telah menyetujui ArTrade untuk memproses informasi pribadi pengguna,
                pengguna dapat mencabut persetujuan pengguna kapan saja dengan mengubah pengaturan akun
                pengguna atau mengirimkan informasi ke ArTrade dan pada saat yang sama menunjukkan
                persetujuan mana yang ingin pengguna cabut. Harap dicatat bahwa pencabutan persetujuan
                pengguna tidak akan memengaruhi legalitas aktivitas pemrosesan apa pun berdasarkan persetujuan
                tersebut sebelum penarikan ini. Selain itu, di beberapa yurisdiksi, undang-undang yang berlaku
                dapat memberi pengguna hak untuk membatasi cara kami menggunakan informasi pribadi
                pengguna, khususnya (i) pengguna mempertanyakan keakuratan informasi pribadi pengguna, (ii)
                pemrosesan itu ilegal dan pengguna keberatan dengan penghapusan informasi pribadi pengguna,
                (iii) kami tidak lagi membutuhkan informasi pribadi pengguna untuk tujuan pemrosesan, tetapi
                pengguna memerlukan informasi untuk informasi yang terkait dengan penetapan, pelaksanaan,
                atau pembelaan klaim hukum, atau (iv) pengguna keberatan dengan pemrosesan sesuai dengan
                Pasal 6.6 dan keberatan menunggu untuk memverifikasi apakah kepentingan sah ArTrade akan
                mengesampingkan kepentingan pengguna sendiri.
            </p>
            <p>
                <strong>6.6. Proses penolakan</strong> <br>
                Di beberapa yurisdiksi, undang-undang yang berlaku dapat mengizinkan pengguna untuk
                meminta entitas pembayaran ArTrade dan ArTrade untuk tidak memproses informasi pribadi
                pengguna untuk tujuan tertentu (termasuk analisis perilaku) dan pemrosesan tersebut didasarkan
                pada kepentingan yang sah. Jika pengguna keberatan dengan pemrosesan tersebut, entitas
                pembayaran ArTrade dan/atau ArTrade tidak akan memproses lagi informasi pribadi pengguna
                untuk tujuan ini, kecuali kami dapat membuktikan bahwa pemrosesan tersebut memiliki alasan
                yang kuat dan masuk akal, atau pemrosesan tersebut ditetapkan, dilaksanakan, atau kondisi yang
                diperlukan untuk membela hak hukum. <br>
                
                Jika informasi pribadi pengguna diproses untuk tujuan pemasaran langsung, pengguna
                dapat meminta ArTrade untuk berhenti memproses data pengguna untuk tujuan pemasaran
                langsung ini kapan saja.
            </p>
            <p>
                <strong>6.7. Mengajukan keluhan</strong> <br>
                Pengguna memiliki hak untuk mengajukan keluhan kepada lembaga perlindungan data
                yang relevan tentang aktivitas pemrosesan data entitas pembayaran ArTrade.
            </p>
            <p>
                <strong>7. Operasi global</strong> <br>
                Untuk memfasilitasi operasi global kami, entitas pembayaran ArTrade dan ArTrade dapat
                mentransfer, menyimpan, dan memproses informasi Pengguna dalam perusahaan grup korporat
                kami atau dengan penyedia layanan. Hukum negara-negara ini mungkin berbeda dari hukum yang
                berlaku di tempat tinggal Pengguna. Misalnya, untuk tujuan "Kebijakan Privasi" ini, informasi
                yang dikumpulkan di Indonesia dapat ditransfer ke luar atau disimpan dan diproses di luar. Dalam
                kasus informasi pribadi yang kami kirimkan, simpan, dan proses di luar, kami telah memastikan
                bahwa tindakan perlindungan yang sesuai telah diambil untuk memastikan perlindungan data yang
                memadai.
            </p>
            <p>
                <strong>8. Keamanan</strong> <br>
                Kami akan terus menerapkan dan memperbarui manajemen, langkah-langkah keamanan
                teknis dan fisik untuk melindungi informasi pengguna dari akses yang tidak sah, kehilangan,
                kerusakan, atau perubahan. Beberapa langkah keamanan yang kami gunakan untuk melindungi
                informasi pengguna adalah firewall, enkripsi data, dan kontrol akses informasi. Jika pengguna
                mengetahui atau memiliki alasan untuk meyakini bahwa informasi akun ArTrade pengguna telah
                hilang, dicuri, disalahgunakan, atau diretas, atau terjadi penyalahgunaan akun ArTrade pengguna
                yang sebenarnya atau dicurigai, ikuti bagian "Hubungi Kami" di bawah instruksi untuk
                menghubungi kami.
            </p>
            <p>
                <strong>9. Perubahan pada "Kebijakan Privasi" ini</strong> <br>
                ArTrade berhak untuk mengubah "Kebijakan Privasi" ini kapan saja sesuai dengan
                ketentuan artikel ini. Jika kami membuat perubahan pada "Kebijakan Privasi" ini, kami akan
                melakukan publikasi "Kebijakan Privasi" yang diubah di ArTrade dan memperbarui tanggal
                "terakhir diperbarui" di bagian atas "Kebijakan Privasi". Kami juga akan mengirimkan email
                pemberitahuan tentang perubahan tersebut setidaknya tiga puluh (30) hari sebelum tanggal
                efektifnya. Jika pengguna tidak setuju dengan "Kebijakan Privasi" yang diubah, pengguna dapat
                keluar dari akun pengguna. Jika pengguna tidak membatalkan akun pengguna sebelum "Kebijakan
                Privasi" yang diubah berlaku, akses pengguna yang berkelanjutan atau penggunaan ArTrade akan
                tunduk pada "Kebijakan Privasi" yang diubah.
            </p>
            <p>
                <strong>10. Hubungi kami</strong> <br>
                Jika pengguna memiliki pertanyaan atau komentar tentang "Kebijakan Privasi" atau
                metode pemrosesan informasi ArTrade ini, Pengguna dapat menghubungi kami melalui situs web
                resmi atau layanan pelanggan aplikasi online, atau menghubungi kami melalui berbagai metode
                kontak yang disediakan oleh ArTrade, ArTrade akan membantu pengguna dalam hal tersebut.
            </p>
        </div>
    </div>
</template>
<script>
    export default{
        name: 'privacy'
    }
</script>